import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { CognitoService } from 'app/core/http/services/cognito.service';
import { OrganizationService } from 'app/core/http/services/organization.service';
import { OrganizationInterface } from 'app/core/interfaces/organization';
import { validateImageFile } from 'app/core/validators/validateImageFile';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { switchMap } from 'rxjs';

@Component({
  selector: 'organization-registration',
  templateUrl: './organization-registration.component.html',
  styleUrls: ['./organization-registration.component.css'],
})
export class OrganizationRegistrationComponent extends BaseComponent implements OnInit {
  public form: FormGroup;

  @Input() organization!: OrganizationInterface;

  public titles = ['Dados de acesso', 'Endereço', 'Horário de atendimento'];

  @Input() mode = 'CREATE';
  @Output() onUpdate = new EventEmitter<OrganizationInterface>();

  profilePictureUrl: string | ArrayBuffer | null = null;
  selectedFileName: string | null = null;

  constructor(
    private fb: FormBuilder,
    private organizationService: OrganizationService,
    private cognitoService: CognitoService,
    private injector: Injector
  ) {
    super(injector);

    this.form = this.fb.group({
      organization_id: new FormControl(null, [Validators.nullValidator]),
      legal_representative: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      alias: new FormControl('', [Validators.required]),
      cnpj: new FormControl('', [Validators.required]),
      active: new FormControl(true),
      photo: new FormControl(''),
    });


  }

  async ngOnInit() {
    this.showSuccessMessage = false;
    this.showErrorMessage = false;

    await this.createOrUpdate();

    this.form.patchValue({
      name: this.organization?.name,
      alias: this.organization?.alias,
      cnpj: this.organization?.cnpj,
      legal_representative: this.organization?.legal_representative,
      photo: this.organization?.photo,
    });

    this.form.valueChanges.subscribe((fields) => {
      this.onChangeForm(fields);
    });

    if (this.mode == 'UPDATE' && localStorage.getItem('isFirstAccess') == 'false') {
      this.getOrganization();
    }
  }

  async createOrUpdate() {
    this.loading = true;
    const userAttributes = await this.cognitoService.getUserAttributes();
    const { standardAttributes, customAttributes } = userAttributes;

    const firstAccess = customAttributes['firstAccess'];
    localStorage.setItem('isFirstAccess', firstAccess);

    if (localStorage.getItem('isFirstAccess') == 'true') {
      this.mode = 'CREATE';
    } else {
      this.mode = 'UPDATE';
    }
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    const photoControl = this.form.controls['photo'];

    if (!file) {
      return;
    }

    const validationResult = validateImageFile(file, 4);

    if (!validationResult.isValid) {
      photoControl.setErrors(validationResult.errors);
      this.profilePictureUrl = null;
      this.selectedFileName = null;

      return;
    }

    photoControl.setErrors(null);
    this.selectedFileName = file.name;

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        const base64 = reader.result as string;
        this.profilePictureUrl = base64;
        this.form.controls['photo'].setValue(base64);
      }
    };
    reader.readAsDataURL(file);
  }


  public getOrganization() {
    const organization_id = this.getUserLogged().id;

    this.organizationService.showNew(organization_id).subscribe({
      next: (organization: OrganizationInterface) => {
        this.organization = organization;
        this.setValuesToFormOrganization(organization);
      },
      error: (err: any) => {
        console.error(err);
      },
    });
  }

  public setValuesToFormOrganization(organization: OrganizationInterface) {
    this.form.controls['organization_id'].setValue(organization?.organization_id);
    this.form.controls['name'].setValue(organization?.name);
    this.form.controls['alias'].setValue(organization?.alias);
    this.form.controls['legal_representative'].setValue(organization.legal_representative);
    this.form.controls['cnpj'].setValue(organization?.cnpj);
    this.form.controls['photo'].setValue(organization?.photo);

    if (organization?.photo) {
      this.profilePictureUrl = organization?.photo;
    } else {
      this.profilePictureUrl = this.defaultOrganizationPhoto;
    }
  }

  create() {

    if (this.form.invalid) {
      this.showErrorMessage = true;
      this.showSuccessMessage = false;
      this.loading = false;
      return;
    }

    this.loading = true;
    this.showErrorMessage = false;
    this.showSuccessMessage = true;

    const payload = this.form.getRawValue();
    payload.mobile = `+55${payload.mobile}`;

    this.organizationService.createNew(payload).subscribe({
      next: (organization: any) => {
       
        this.showErrorMessage = false;
        this.showSuccessMessage = true;

        this.form.patchValue({
          organization_id: organization.organization_id,
        });

        this.auth.setUser(organization, localStorage.getItem('userType'), localStorage.getItem('token'), localStorage.getItem('token_id'));
        // localStorage.setItem("tabAfterReload", "localizacao")
        this.organization = organization;
        this.mode = "UPDATE"
        this.cognitoService.updateFirstAccess();


        setTimeout(() => {
          this.router.navigate(
            ['organization-new/meus-dados'],
            { queryParams: { tab: 'localizacao' } }
          );
           this.loading = false;
        }, 500);

      },
      error: (error: HttpErrorResponse) => {

        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.loading = false;

        if (error.status == 413) {
          this.messageError = 'Imagem enviada ultrapassa o tamanho máximo permitido de 4MB'
          return
        }

        this.messageError =  error.error.message || error.message
      },
    });
  }

  save() {
    this.loading = true;

    if (this.form.invalid) {
      this.showErrorMessage = true;
      this.showSuccessMessage = false;
      this.loading = false;
      return;
    }

    const organization_id = this.getUserLogged().id;

    const payload = this.form.getRawValue();
    payload.mobile = `+55${payload.mobile}`;


    const organizationFormValues = {
      ...this.organization,
      ...payload,
    };

    this.organizationService.updateNew(organization_id, organizationFormValues).subscribe({
      next: (organization) => {
        this.loading = false;
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
      },
      error: (error: HttpErrorResponse) => {

        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.loading = false;

        if (error.status == 413) {
          this.messageError = 'Imagem enviada ultrapassa o tamanho máximo permitido de 4MB'
          return
        }

       this.messageError =  error.error.message || error.message
      },
    });
  }

  hasError(field: string) {
    const organization: any = this.organization;
    if (organization[field] == '') {
      return true;
    }
    return false;
  }

  onChangeForm(fields: OrganizationInterface) {
    this.onUpdate.emit(fields);
  }
}
